import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Layout from '../layout';

function Terms({ component: Component, auth, ...rest }: any) {
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const acceptedTerms = useSelector(
    (state: ApplicationState) => state.auth.user?.acceptedTerms
  );
  const terms = useSelector(
    (state: ApplicationState) => state.config.termosUso
  );

  return (
    <Route
      {...rest}
      render={(props) =>
        token ? (
          acceptedTerms ? (
            <Redirect to='/contrato' />
          ) : terms ? (
            <Layout>
              <Component {...props} />
            </Layout>
          ) : (
            <Redirect to='/contrato' />
          )
        ) : (
          <Redirect to='/' />
        )
      }
    />
  );
}

export default Terms;
